const UserRoles = {
    RegularUser: "1",
    AdminUser: "2",
};

export default UserRoles;